import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

import { dispatchTrackingEvent } from '@context/tracking/utils';
import { ProductEventWither } from '@helpers/googleTagManager';
import { IWatchdogProps } from '@sharedComponents/Watchdog/model';

export const trackWatchdogSent = (
  email: string,
  product: IWatchdogProps['variant']
) => {
  dispatchTrackingEvent({
    event: 'watchdog_submit',
    watchdog: {
      action: 'watchdog_submitted',
      interaction: 'button',
      type: 'modal',
      products: [
        ProductEventWither()
          .withPartialProduct(
            product as Parameters<
              ReturnType<typeof ProductEventWither>['withPartialProduct']
            >[0]
          )
          .withPartialVariant(
            product as Parameters<
              ReturnType<typeof ProductEventWither>['withPartialVariant']
            >[0]
          )
          .build(),
      ],
      email,
      emailHashed: undefined as unknown as string,
    },
    _clear: true,
  });
};

export const trackWatchdogClick = (
  product: NonNullable<
    GetCatalogProductViewQuery['productDetailByCatalogMasterId']
  >,
  variant: NonNullable<
    GetCatalogProductViewQuery['productDetailByCatalogMasterId']
  >['variants'][number]
) => {
  dispatchTrackingEvent({
    event: 'watchdog_click',
    watchdog: {
      action: 'wt_add_watchdog',
      interaction: 'button',
      type: 'Drawer',
      products: [
        ProductEventWither()
          .withProduct(
            product as Parameters<
              ReturnType<typeof ProductEventWither>['withProduct']
            >[0]
          )
          .withVariant(variant)
          .build(),
      ],
    },
    _clear: true,
  });
};
